import { Permission, SecurityScope } from '../../../../../auth/auth.model';
import { AuthService } from '../../../../../auth/auth.service';
import { epicDependencies } from '../../../../../store';
import { AllowedActions } from '../../../../transcript-dialog/model/allowed-actions.model';

export function determineAllowedActions(): AllowedActions {
    const service = epicDependencies?.injector?.get<AuthService>(AuthService); // TODO FIXME revise

    const canEditTranscript = service?.user.hasPermission(
        Permission.TEAMS_CALL_EDIT_TRANSCRIPT,
        SecurityScope.COACHING,
    );
    const canDeleteQuotes = service?.user.hasPermission(
        Permission.TEAMS_CALL_DELETE_TRANSCRIPT_QUOTES,
        SecurityScope.COACHING,
    );

    return {
        editTranscript: canEditTranscript,
        deleteQuotes: canDeleteQuotes,
    };
}
